export type Country = { name: string; iso2: string; dialCode: string; flag: string; priority?: number };

export const COUNTRIES: Country[] = [
  { name: "United Kingdom", iso2: "GB", dialCode: "+44",  flag: "🇬🇧", priority: 0 },
  { name: "United States",  iso2: "US", dialCode: "+1",   flag: "🇺🇸", priority: 1 },
  { name: "Ireland",        iso2: "IE", dialCode: "+353", flag: "🇮🇪", priority: 2 },
  { name: "United Arab Emirates", iso2: "AE", dialCode: "+971", flag: "🇦🇪", priority: 3 },
  { name: "Singapore",      iso2: "SG", dialCode: "+65",  flag: "🇸🇬", priority: 4 },
  // — Common EU/APAC set (add/remove freely)
  { name: "Australia", iso2: "AU", dialCode: "+61", flag: "🇦🇺" },
  { name: "Austria",   iso2: "AT", dialCode: "+43", flag: "🇦🇹" },
  { name: "Belgium",   iso2: "BE", dialCode: "+32", flag: "🇧🇪" },
  { name: "Canada",    iso2: "CA", dialCode: "+1",  flag: "🇨🇦" },
  { name: "Denmark",   iso2: "DK", dialCode: "+45", flag: "🇩🇰" },
  { name: "Finland",   iso2: "FI", dialCode: "+358",flag: "🇫🇮" },
  { name: "France",    iso2: "FR", dialCode: "+33", flag: "🇫🇷" },
  { name: "Germany",   iso2: "DE", dialCode: "+49", flag: "🇩🇪" },
  { name: "Greece",    iso2: "GR", dialCode: "+30", flag: "🇬🇷" },
  { name: "Hong Kong", iso2: "HK", dialCode: "+852",flag: "🇭🇰" },
  { name: "India",     iso2: "IN", dialCode: "+91", flag: "🇮🇳" },
  { name: "Italy",     iso2: "IT", dialCode: "+39", flag: "🇮🇹" },
  { name: "Japan",     iso2: "JP", dialCode: "+81", flag: "🇯🇵" },
  { name: "Luxembourg",iso2: "LU", dialCode: "+352",flag: "🇱🇺" },
  { name: "Malaysia",  iso2: "MY", dialCode: "+60", flag: "🇲🇾" },
  { name: "Netherlands",iso2:"NL", dialCode: "+31", flag: "🇳🇱" },
  { name: "New Zealand",iso2:"NZ", dialCode: "+64", flag: "🇳🇿" },
  { name: "Norway",    iso2: "NO", dialCode: "+47", flag: "🇳🇴" },
  { name: "Poland",    iso2: "PL", dialCode: "+48", flag: "🇵🇱" },
  { name: "Portugal",  iso2: "PT", dialCode: "+351",flag: "🇵🇹" },
  { name: "Qatar",     iso2: "QA", dialCode: "+974",flag: "🇶🇦" },
  { name: "Saudi Arabia", iso2:"SA", dialCode:"+966", flag:"🇸🇦" },
  { name: "South Africa", iso2:"ZA", dialCode:"+27",  flag:"🇿🇦" },
  { name: "Spain",     iso2: "ES", dialCode: "+34", flag: "🇪🇸" },
  { name: "Sweden",    iso2: "SE", dialCode: "+46", flag: "🇸🇪" },
  { name: "Switzerland",iso2:"CH", dialCode:"+41", flag:"🇨🇭" },
  { name: "Thailand",  iso2: "TH", dialCode: "+66", flag: "🇹🇭" },
  { name: "Turkey",    iso2: "TR", dialCode: "+90", flag: "🇹🇷" },
  { name: "Vietnam",   iso2: "VN", dialCode: "+84", flag: "🇻🇳" },
];

export const SORTED_COUNTRIES = [...COUNTRIES].sort((a, b) => {
  const ap = a.priority ?? 999, bp = b.priority ?? 999;
  return ap !== bp ? ap - bp : a.name.localeCompare(b.name);
});

export const textOnlyOptions = () =>
  SORTED_COUNTRIES.map(c => ({
    value: c.dialCode,
    label: `${c.flag} ${c.dialCode} (${c.name})`,
    iso2: c.iso2,
  }));

export const formatIntl = (dialCode: string, local: string) =>
  [dialCode, (local || "").trim()].filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
